<template lang="pug">
div
    Button(type="primary" @click="isModal = true" icon="md-more" )
    Modal(v-model="isModal" :title="title" width="50" @on-cancel='cancel' footer-hide=true)
        Form(style="width: 20" :model="value")
            Row(v-for="(item) in data.filter((e)=>e.type!='object')" :key="item.id")
                Col(span="24")
                    FormItem(:label='$t("backendsTitle."+item.id)' :label-width="150")
                        component(:is="item.type" :value="item.value" :disabled="item.disabled" :min="0" :max="item.max" :step="item.step" @[item.fun]="changeData(item,$event)")
                            Option(v-if="item.type === 'Select' " v-for="(i) in item.options" :value="i.value" :key="i.value") {{ i.label }}
            Row(type="flex" justify="end")
                Button(type="primary" @click="add" ) {{ 'add' }}
            Row
                Content(:style="{maxHeight: '600px'}")
                    Layout
                        Sider(hide-trigger :style="{background: '#fff',maxHeight: '600px',overflow: 'auto'}" )
                            Menu(theme="light" width="200px" @on-select='selectMenu' :active-name="currentTab")
                                template(v-for="(item,index) in menuData")
                                    MenuItem(:name="item.name")
                                        span(v-text="item.name")
                                        Button(size="small" icon="md-close" shape="circle" type="text" @click="remove(item.name)")
                        Content(:style="{padding: '10px', background: '#fff' ,maxHeight: '600px',overflow: 'auto'}")
                            Row
                                Col(span="24")
                                    Table.table(
                                        ref="xTable"
                                        :key="tabKey"
                                        :class="tableHeaderStyle" 
                                        :border="withBorder" 
                                        style="margin-top: 8px;margin-bottom: 8px;text-overflow: ellipsis" 
                                        :loading="isTableLoading" 
                                        :size="tableSize" 
                                        :columns="tableColumns[currentTab]"
                                        :data="tableData")
        Row(type="flex" justify="end")
            Button(type="primary"  @click="ok"  :disabled="!value['isPurchase']") OK
</template>
<script>
import FormSelect from "./Select/index.js";
export default {
    name: "setRoleExampleModel",
    components: {
        FormSelect,
    },
    props: ["value", "title", "option"],
    data() {
        return {
            isModal: false,
            tabKey: 0,
            isTableLoading: false,
            tableSize: "default",
            data: [],
            rmFiles: [
                "isPurchase",
                "isShown",
                "name",
                "type",
                "formRender",
                "id",
                "value",
                "validityExtend",
                "price",
                "discount",
                "rmFornt",
            ],
            notCanEditFiles: ["validityStart", "validityEnd"],
            currentTab: "",
            menuData: [],
            changeField: [],
            tableColumns: {},
            tableData: [],
            changeName: [],
            removeName: [],
            newNameValue: "",
        };
    },
    computed: {
        tableHeaderStyle() {
            return this.$store.getters.getTableConfig.headerStyle;
        },
        withBorder() {
            return this.$store.getters.getTableConfig.withBorder;
        },
        isGlobalScope() {
            return !this.data.find((e) => e.id == "isGlobalScope").value;
        },
    },
    watch: {},
    methods: {
        async setTables() {
            let objKeys = Object.keys(this.value);
            this.data = objKeys
                .map((e) => {
                    let obj = {};
                    if (this.rmFiles.includes(e)) {
                        return obj;
                    } else if (typeof this.value[e] == "boolean") {
                        obj["type"] = "i-switch";
                        obj["fun"] = "on-change";
                    } else if (typeof this.value[e] == "string") {
                        obj["type"] = "Input";
                        obj["fun"] = "on-blur";
                    } else if (typeof this.value[e] == "number") {
                        obj["type"] = "InputNumber";
                        obj["fun"] = "on-change";
                    } else if (typeof this.value[e] == "object") {
                        obj["type"] = "object";

                        if (this.menuData.length == 0) {
                            this.menuData = this.value[e];
                        }

                        this.menuData.forEach((column) => {
                            this.tableColumns[column.name] = [];
                            Object.keys(this.option[this.title][0]).forEach((key) => {
                                let render;
                                if (typeof this.option[this.title][0][key] == "boolean") {
                                    render = (h, params) => {
                                        return renderSwitch(key, column.name, h, params, this);
                                    };
                                }
                                this.tableColumns[column.name].push({
                                    title: key,
                                    key: key,
                                    render: render,
                                });
                            });
                        });
                    }
                    obj["id"] = e;
                    obj["value"] = this.value[e];
                    obj["disabled"] = !this.value["isPurchase"];
                    if (this.notCanEditFiles.includes(e)) {
                        obj["disabled"] = true;
                    }
                    return obj;
                })
                .filter((e) => e.id);
        },
        ok() {
            if (this.isModal) {
                let renObj = {};
                this.data.forEach((e) => {
                    if (this.changeField.includes(e.id)) renObj[e.id] = e.value;
                });
                // 把要異動的群組排除
                renObj["groupScope"] = this.data
                    .find((e) => e.id == "groupScope")
                    .value.filter((e) => !this.changeName.includes(e.name));

                // 新增本次修改的群組設定
                this.changeName.forEach((name) => {
                    let pushGroup = this.menuData.find((e) => e.name == name);
                    if (pushGroup) renObj["groupScope"].push(pushGroup);
                });
                // 移除群組
                this.removeName.forEach((name) => {
                    renObj["groupScope"] = renObj["groupScope"].filter((item) => item.name != name);
                });
                this.isModal = false;
                this.$emit("changeData", this.title, renObj);
            }
        },
        cancel() {
            this.setTables();
        },
        changeData(item, $event) {
            let changeVal = $event;
            if ($event.target) {
                changeVal = $event.target._value;
            }
            this.data = this.data.map((e) => {
                if (e.id == item.id) {
                    e.value = changeVal;
                }
                return e;
            });
            if (!this.changeField.find((e) => e == item.id)) this.changeField.push(item.id);
        },
        selectMenu(roleName) {
            this.currentTab = roleName;
            this.tableData = this.menuData.find((e) => e.name == roleName)
                ? this.menuData.find((e) => e.name == roleName).data
                : [];
        },
        add() {
            var self = this;
            this.$Modal.confirm({
                render: (h) => {
                    return h("Input", {
                        props: {
                            value: self.newNameValue,
                            autofocus: true,
                            placeholder: "Please enter your name...",
                        },
                        on: {
                            input: (val) => {
                                self.newNameValue = val;
                            },
                        },
                    });
                },
                onOk: async function () {
                    if (self.menuData.find((item) => item.name == self.newNameValue)) {
                        self.$Message.error("Name already in use...");
                        return;
                    }
                    if (self.newNameValue == "") {
                        self.$Message.error("Name is empty...");
                        return;
                    }

                    // 記錄修改的名稱
                    if (!self.changeName.includes(self.newNameValue)) {
                        self.changeName.push(self.newNameValue);
                    }

                    self.removeName = self.removeName.filter((itemName) => itemName != self.newNameValue);

                    self.$Message.success(self.$t("global.success"));
                    self.menuData.push({
                        name: self.newNameValue,
                        data: JSON.parse(JSON.stringify(self.option[self.title])),
                    });
                    self.newNameValue = "";
                    self.setTables();
                },
            });
        },
        remove(name) {
            this.$Modal.confirm({
                title: "移除選項",
                content: `您確定要移除${name}嗎?`,
                okText: "確定",
                onOk: async () => {
                    // 記錄修改的名稱
                    if (!this.removeName.includes(name)) {
                        this.removeName.push(name);
                    }
                    this.menuData = this.menuData.filter((e) => e.name != name);
                    this.$Message.success(this.$t("global.success"));
                    this.selectMenu("");
                    this.changeName = this.changeName.filter((itemName) => itemName != name);
                    this.data = this.data.map((e) => {
                        if (e.id == "groupScope") {
                            e.value = e.value.filter((item) => item.name != name);
                        }
                        return e;
                    });
                },
            });
        },
    },
    mounted() {},
    created() {
        this.setTables();
    },
    destroyed() {},
    beforeDestroy() {},
};

let renderSwitch = (key, name, h, params, vm) => {
    return h("i-switch", {
        props: {
            trueColor: "default",
            value: params.row[params.column.key],
        },
        on: {
            "on-change": (value) => {
                // console.log(
                //     `name:${name}, key:${key}, params.index:${params.index}, params.column.key:${params.column.key},`
                // );

                vm.menuData = vm.menuData.map((column) => {
                    if (column.name == name) {
                        column.data[params.index][params.column.key] = value;
                    }
                    return column;
                });

                // 記錄修改的名稱
                if (!vm.changeName.includes(name)) {
                    vm.changeName.push(name);
                }
            },
        },
    });
};
</script>



// WEBPACK FOOTER //
// src/components/rcmTableFormItems/setRoleExampleModel.vue